/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: Date | string;
  JSON: any;
};

export type Area = {
  __typename?: 'Area';
  category: AreaCategory;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum AreaCategory {
  BUURT = 'BUURT',
  STADSDEEL = 'STADSDEEL',
  WIJK = 'WIJK'
}

export type AuthUserType = {
  __typename?: 'AuthUserType';
  id: Scalars['ID'];
  managerHasAccessToSensitiveMessages: Scalars['Boolean'];
  name: Scalars['String'];
  role?: Maybe<Role>;
};

export type Capacity = {
  __typename?: 'Capacity';
  age?: Maybe<Array<Scalars['Int']>>;
  capacity: Scalars['Int'];
  description: Scalars['String'];
  expectedTurnover3months?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isUkraineOnly: Scalars['Boolean'];
  remainingCapacity: Scalars['Int'];
  reservedCapacity: Scalars['Int'];
  totalCapacity: Scalars['Int'];
};

export type CombinedArea = {
  __typename?: 'CombinedArea';
  buurt?: Maybe<Area>;
  stadsdeel?: Maybe<Area>;
  wijk?: Maybe<Area>;
};

export enum DisabilitySupport {
  BEHAVIORAL_PROBLEMS = 'BEHAVIORAL_PROBLEMS',
  CHRONIC_DISEASE = 'CHRONIC_DISEASE',
  DEVELOPMENTAL_DELAY = 'DEVELOPMENTAL_DELAY',
  NONE = 'NONE',
  OTHER = 'OTHER',
  PHYSICAL_LIMITATION = 'PHYSICAL_LIMITATION'
}

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String'];
  message: Scalars['String'];
};

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER'
}

export enum Language {
  GB = 'GB',
  NL = 'NL',
  OTHER = 'OTHER',
  RU = 'RU',
  UA = 'UA'
}

export type LocationDistance = {
  __typename?: 'LocationDistance';
  distance: Scalars['Float'];
  location: WegwijzerLocationType;
};

export type LocationType = StringLocationType | WegwijzerLocationType;

export type Mutation = {
  __typename?: 'Mutation';
  createNote: CreateOrUpdateNoteOutput;
  createOrUpdatePlacementOffer: UpdatePlacementOfferOutput;
  createOrUpdateUser: CreateOrUpdateUserOutput;
  deleteNote: Note;
  resetOtp: Scalars['Boolean'];
  setLocationNewcomerAvailableCapacity: SetLocationNewcomerAvailableCapacityOutput;
  updateNewcomer: UpdateNewcomerOutput;
  updateNote: CreateOrUpdateNoteOutput;
  updateOrCreateObject: CreateOrUpdateObjectOutput;
  updateSettings: UpdateSettingsOutput;
};


export type MutationCreateNoteArgs = {
  input: NoteInput;
};


export type MutationCreateOrUpdatePlacementOfferArgs = {
  input: CreateOrUpdatePlacementOfferInput;
};


export type MutationCreateOrUpdateUserArgs = {
  input: CreateOrUpdateUserInput;
};


export type MutationDeleteNoteArgs = {
  id: Scalars['Int'];
};


export type MutationResetOtpArgs = {
  userId: Scalars['ID'];
};


export type MutationSetLocationNewcomerAvailableCapacityArgs = {
  locationId: Scalars['ID'];
  newcomerAvailableCapacity?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateNewcomerArgs = {
  input: NewComerUpdateInput;
};


export type MutationUpdateNoteArgs = {
  id: Scalars['Int'];
  text: Scalars['String'];
};


export type MutationUpdateOrCreateObjectArgs = {
  input: UpdateOrCreateObjectInput;
};


export type MutationUpdateSettingsArgs = {
  input: SettingsUpdateInput;
};

export type NewComer = Node & {
  __typename?: 'NewComer';
  CDW?: Maybe<Scalars['String']>;
  LBAArrivalDate?: Maybe<Scalars['Date']>;
  LBACurrentResidence?: Maybe<Scalars['String']>;
  LBASchool?: Maybe<Scalars['String']>;
  LBASchoolPhone?: Maybe<Scalars['String']>;
  LBASchoolTownship?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  alreadyGoingToSchoolInNetherlands?: Maybe<Scalars['Boolean']>;
  alreadyInNetherlands?: Maybe<Scalars['Boolean']>;
  arrivalDate?: Maybe<Scalars['Date']>;
  centralSignupRemarks?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityArea?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  countryOfOrigin?: Maybe<Scalars['String']>;
  currentSchool?: Maybe<WegwijzerLocationType>;
  currentSchoolStartDate?: Maybe<Scalars['Date']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  disabilitySupport?: Maybe<Array<DisabilitySupport>>;
  disabilitySupportExplanationNote?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  gender?: Maybe<Gender>;
  hasInterpreter?: Maybe<Scalars['Boolean']>;
  hasSibling?: Maybe<Scalars['Boolean']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isUkrainian?: Maybe<Scalars['Boolean']>;
  languages: Array<Language>;
  lastName: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  nearbyLocations: Array<LocationDistance>;
  neighbourhood?: Maybe<Scalars['String']>;
  neighbourhoodNumber?: Maybe<Scalars['Int']>;
  newCity?: Maybe<Scalars['String']>;
  newHouseNumber?: Maybe<Scalars['String']>;
  newStreet?: Maybe<Scalars['String']>;
  newZip?: Maybe<Scalars['String']>;
  notes: Array<Note>;
  otherLanguages?: Maybe<Scalars['String']>;
  parentEmail?: Maybe<Scalars['String']>;
  parentFirstName?: Maybe<Scalars['String']>;
  parentLastName?: Maybe<Scalars['String']>;
  parentPhone?: Maybe<Scalars['String']>;
  placementOffers: Array<PlacementOffer>;
  placementStatus?: Maybe<PlacementStatus>;
  poGroup?: Maybe<Scalars['Int']>;
  poVo: PoVo;
  registrationDate: Scalars['Date'];
  remarks?: Maybe<Scalars['String']>;
  schoolPlacement?: Maybe<WegwijzerLocationType>;
  statusHistory: Array<NewComerStatusHistory>;
  street?: Maybe<Scalars['String']>;
  timeline: Array<TimelineItem>;
  willMoveSoon?: Maybe<Scalars['Boolean']>;
  zip?: Maybe<Scalars['String']>;
};


export type NewComerNearbyLocationsArgs = {
  radius: Scalars['Float'];
};


export type NewComerTimelineArgs = {
  invertOrder?: InputMaybe<Scalars['Boolean']>;
};

export type NewComerStatusHistory = {
  __typename?: 'NewComerStatusHistory';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  newComer: NewComer;
  oldStatus?: Maybe<PlacementStatus>;
  status?: Maybe<PlacementStatus>;
};

export type NewComerUpdateInput = {
  CDW?: InputMaybe<Scalars['String']>;
  LBAArrivalDate?: InputMaybe<Scalars['Date']>;
  LBACurrentResidence?: InputMaybe<Scalars['String']>;
  LBASchool?: InputMaybe<Scalars['String']>;
  LBASchoolPhone?: InputMaybe<Scalars['String']>;
  LBASchoolTownship?: InputMaybe<Scalars['String']>;
  alreadyGoingToSchoolInNetherlands?: InputMaybe<Scalars['Boolean']>;
  alreadyInNetherlands?: InputMaybe<Scalars['Boolean']>;
  arrivalDate?: InputMaybe<Scalars['Date']>;
  centralSignupRemarks?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityArea?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  countryOfOrigin?: InputMaybe<Scalars['String']>;
  currentSchool?: InputMaybe<Scalars['String']>;
  currentSchoolStartDate?: InputMaybe<Scalars['Date']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  disabilitySupport?: InputMaybe<Array<DisabilitySupport>>;
  disabilitySupportExplanationNote?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  hasInterpreter?: InputMaybe<Scalars['Boolean']>;
  hasSibling?: InputMaybe<Scalars['Boolean']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isUkrainian?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<Language>>;
  lastName?: InputMaybe<Scalars['String']>;
  neighbourhood?: InputMaybe<Scalars['String']>;
  neighbourhoodNumber?: InputMaybe<Scalars['Int']>;
  newCity?: InputMaybe<Scalars['String']>;
  newHouseNumber?: InputMaybe<Scalars['String']>;
  newStreet?: InputMaybe<Scalars['String']>;
  newZip?: InputMaybe<Scalars['String']>;
  otherLanguages?: InputMaybe<Scalars['String']>;
  parentEmail?: InputMaybe<Scalars['String']>;
  parentFirstName?: InputMaybe<Scalars['String']>;
  parentLastName?: InputMaybe<Scalars['String']>;
  parentPhone?: InputMaybe<Scalars['String']>;
  placementStatus?: InputMaybe<PlacementStatus>;
  poGroup?: InputMaybe<Scalars['Int']>;
  poVo?: InputMaybe<PoVo>;
  registrationDate?: InputMaybe<Scalars['Date']>;
  remarks?: InputMaybe<Scalars['String']>;
  schoolPlacement?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  willMoveSoon?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Node = {
  id: Scalars['ID'];
};

export type Note = {
  __typename?: 'Note';
  createdAt: Scalars['Date'];
  createdBy?: Maybe<UserType>;
  id: Scalars['ID'];
  newcomer: NewComer;
  text: Scalars['String'];
};

export type NoteInput = {
  newcomer: Scalars['ID'];
  text: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PlacementOffer = {
  __typename?: 'PlacementOffer';
  cancelledAt?: Maybe<Scalars['Date']>;
  cancelledBy?: Maybe<Scalars['Int']>;
  capacity?: Maybe<Capacity>;
  createdAt: Scalars['Date'];
  date: Scalars['Date'];
  failureReason?: Maybe<Scalars['String']>;
  finalized: Scalars['Boolean'];
  finalizedAt?: Maybe<Scalars['Date']>;
  finalizedBy?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location?: Maybe<WegwijzerLocationType>;
  locationName?: Maybe<Scalars['String']>;
  needsFinalized: Scalars['Boolean'];
  newcomer: NewComer;
  newcomerName?: Maybe<Scalars['String']>;
  resolution: PlacementOfferResolution;
  resolutionAt?: Maybe<Scalars['Date']>;
  resolutionBy?: Maybe<UserType>;
  school?: Maybe<Scalars['String']>;
};

export enum PlacementOfferResolution {
  ACCEPTED = 'ACCEPTED',
  AWAITING_RESOLUTION = 'AWAITING_RESOLUTION',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED'
}

export enum PlacementStatus {
  ALREADY_FOUND_A_SCHOOL = 'ALREADY_FOUND_A_SCHOOL',
  COMPULSORY_EDUCATION = 'COMPULSORY_EDUCATION',
  DOUBLE_REGISTRATION = 'DOUBLE_REGISTRATION',
  EXEMPT_FROM_EDUCATION = 'EXEMPT_FROM_EDUCATION',
  IMPROVEMENT_NEEDED = 'IMPROVEMENT_NEEDED',
  LEFT = 'LEFT',
  NEW = 'NEW',
  NO_CONTACT = 'NO_CONTACT',
  OUTSIDE_THE_HAGUE = 'OUTSIDE_THE_HAGUE',
  PLACED = 'PLACED',
  PLACED_ARRIVAL_LOCATION = 'PLACED_ARRIVAL_LOCATION',
  PLACED_TEMPORARY_LOCATION = 'PLACED_TEMPORARY_LOCATION',
  REFUSSAL = 'REFUSSAL',
  RESERVED = 'RESERVED',
  SIGNUP_PO = 'SIGNUP_PO',
  SIGNUP_VO = 'SIGNUP_VO',
  TODDLER = 'TODDLER',
  TODDLER_WAITING_LIST = 'TODDLER_WAITING_LIST',
  WAITING_LIST = 'WAITING_LIST',
  WAITING_LIST_ARRIVAL_LOCATION = 'WAITING_LIST_ARRIVAL_LOCATION',
  WAITING_LIST_CARE = 'WAITING_LIST_CARE',
  WAITING_LIST_TEMPORARY_LOCATION = 'WAITING_LIST_TEMPORARY_LOCATION',
  YET_TO_ARRIVE = 'YET_TO_ARRIVE'
}

export enum PoVo {
  PO = 'PO',
  VO = 'VO'
}

export type Query = {
  __typename?: 'Query';
  areas: Array<Area>;
  location?: Maybe<WegwijzerLocationType>;
  locationArea?: Maybe<CombinedArea>;
  locations: QueryLocationsConnection;
  me: AuthUserType;
  newcomer?: Maybe<NewComer>;
  newcomers: QueryNewcomersConnection;
  node?: Maybe<Node>;
  nodes: Array<Maybe<Node>>;
  note?: Maybe<Note>;
  placementOffer?: Maybe<PlacementOffer>;
  placementOffers: QueryPlacementOffersConnection;
  report: Report;
  reports: Array<Report>;
  settings: Settings;
  user?: Maybe<UserType>;
  users: Array<UserType>;
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryLocationAreaArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  distanceRadius?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  isNewcomer?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderByDistanceFromNewcomerId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryNewcomerArgs = {
  id: Scalars['ID'];
};


export type QueryNewcomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  areaId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<PoVo>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  oldFirst?: InputMaybe<Scalars['Boolean']>;
  placementStatus__in?: InputMaybe<Array<PlacementStatus>>;
  placementStatus__notIn?: InputMaybe<Array<PlacementStatus>>;
  rangeFilter?: InputMaybe<RangeFilter>;
  search?: InputMaybe<Scalars['String']>;
  shouldHaveBeenPlaced?: InputMaybe<Scalars['Boolean']>;
  speaksUkrainian?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryNoteArgs = {
  id: Scalars['ID'];
};


export type QueryPlacementOfferArgs = {
  id: Scalars['ID'];
};


export type QueryPlacementOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QuerySettingsArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  newcomerUser?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryLocationsConnection = {
  __typename?: 'QueryLocationsConnection';
  edges: Array<QueryLocationsConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryLocationsConnectionEdge = {
  __typename?: 'QueryLocationsConnectionEdge';
  cursor: Scalars['String'];
  node: WegwijzerLocationType;
};

export type QueryNewcomersConnection = {
  __typename?: 'QueryNewcomersConnection';
  edges: Array<QueryNewcomersConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryNewcomersConnectionEdge = {
  __typename?: 'QueryNewcomersConnectionEdge';
  cursor: Scalars['String'];
  node: NewComer;
};

export type QueryPlacementOffersConnection = {
  __typename?: 'QueryPlacementOffersConnection';
  edges: Array<QueryPlacementOffersConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryPlacementOffersConnectionEdge = {
  __typename?: 'QueryPlacementOffersConnectionEdge';
  cursor: Scalars['String'];
  node: PlacementOffer;
};

export type RangeFilter = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  metersRange?: InputMaybe<Scalars['Int']>;
};

export type Report = {
  __typename?: 'Report';
  downloadAsBase64: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum Role {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  EDITORIAL_STAFF = 'EDITORIAL_STAFF',
  MEMBER = 'MEMBER'
}

export type SetLocationNewcomerAvailableCapacityOutput = {
  __typename?: 'SetLocationNewcomerAvailableCapacityOutput';
  errors: Array<Scalars['String']>;
  locationId: Scalars['String'];
  newcomerAvailableCapacity?: Maybe<Scalars['Int']>;
};

export type Settings = {
  __typename?: 'Settings';
  defaultConfirmationTextEN: Scalars['String'];
  defaultConfirmationTextNL: Scalars['String'];
  id: Scalars['ID'];
  overrideConfirmationEndDate?: Maybe<Scalars['Date']>;
  overrideConfirmationStartDate?: Maybe<Scalars['Date']>;
  overrideConfirmationTextEN?: Maybe<Scalars['String']>;
  overrideConfirmationTextNL?: Maybe<Scalars['String']>;
};

export type SettingsUpdateInput = {
  defaultConfirmationTextEN?: InputMaybe<Scalars['String']>;
  defaultConfirmationTextNL?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  overrideConfirmationEndDate?: InputMaybe<Scalars['Date']>;
  overrideConfirmationStartDate?: InputMaybe<Scalars['Date']>;
  overrideConfirmationTextEN?: InputMaybe<Scalars['String']>;
  overrideConfirmationTextNL?: InputMaybe<Scalars['String']>;
};

export type StringLocationType = {
  __typename?: 'StringLocationType';
  name: Scalars['String'];
};

export type UpdateNewcomerOutput = {
  __typename?: 'UpdateNewcomerOutput';
  errors: Array<ErrorType>;
  newcomer?: Maybe<NewComer>;
};

export type UpdateOrCreateObjectInput = {
  id?: InputMaybe<Scalars['ID']>;
  model: Scalars['String'];
  values: Scalars['JSON'];
};

export type UpdatePlacementOfferOutput = {
  __typename?: 'UpdatePlacementOfferOutput';
  errors: Array<ErrorType>;
  placementOffer?: Maybe<PlacementOffer>;
};

export type UpdateSettingsOutput = {
  __typename?: 'UpdateSettingsOutput';
  errors: Array<ErrorType>;
  settings?: Maybe<Settings>;
};

export type UserType = {
  __typename?: 'UserType';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  newcomerLocations: Array<WegwijzerLocationType>;
  otpActive: Scalars['Boolean'];
  role?: Maybe<Role>;
};

export type WegwijzerLocationType = Node & {
  __typename?: 'WegwijzerLocationType';
  capacity?: Maybe<Array<Capacity>>;
  capacityDisplay?: Maybe<Scalars['String']>;
  capacityUpdatedAt?: Maybe<Scalars['Date']>;
  cityAreaName?: Maybe<Scalars['String']>;
  distanceToNewcomer?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['Int']>;
  houseNumberAddition?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastReactionOnPlacementOffer?: Maybe<Scalars['Date']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  newcomerAvailableCapacity: Scalars['Int'];
  newcomerSpaceForSiblings?: Maybe<Scalars['Boolean']>;
  newcomerToken?: Maybe<Scalars['String']>;
  oldestPlacementOffer?: Maybe<Scalars['Date']>;
  place?: Maybe<Scalars['String']>;
  remainingCapacity: Scalars['Int'];
  reservedCapacity: Scalars['Int'];
  street?: Maybe<Scalars['String']>;
  totalCapacity: Scalars['Int'];
  zipcode?: Maybe<Scalars['String']>;
};


export type WegwijzerLocationTypeDistanceToNewcomerArgs = {
  newcomerId?: InputMaybe<Scalars['ID']>;
};

export type CreateOrUpdateNoteOutput = {
  __typename?: 'createOrUpdateNoteOutput';
  errors: Array<ErrorType>;
  note?: Maybe<Note>;
};

export type CreateOrUpdateObjectOutput = {
  __typename?: 'createOrUpdateObjectOutput';
  errors: Array<ErrorType>;
  object?: Maybe<Scalars['JSON']>;
};

export type CreateOrUpdatePlacementOfferInput = {
  capacity?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  failureReason?: InputMaybe<Scalars['String']>;
  finalized?: InputMaybe<Scalars['Boolean']>;
  finalizedAt?: InputMaybe<Scalars['Date']>;
  finalizedBy?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  newcomer?: InputMaybe<Scalars['ID']>;
  newcomerStatus?: InputMaybe<PlacementStatus>;
  resolution?: InputMaybe<PlacementOfferResolution>;
  resolutionAt?: InputMaybe<Scalars['Date']>;
  resolutionBy?: InputMaybe<Scalars['ID']>;
};

export type CreateOrUpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  newcomerLocations?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateOrUpdateUserOutput = {
  __typename?: 'createOrUpdateUserOutput';
  errors: Array<ErrorType>;
  user?: Maybe<UserType>;
};

export type TimelineItem = NewComerStatusHistory | Note | PlacementOffer;

export type AppComponent_UserQueryVariables = Exact<{ [key: string]: never; }>;


export type AppComponent_UserQuery = { __typename?: 'Query', me: { __typename?: 'AuthUserType', id: string, name: string } };

export type LocationComponent_InformationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationComponent_InformationQuery = { __typename?: 'Query', location?: { __typename?: 'WegwijzerLocationType', id: string, name: string, street?: string | null, houseNumber?: number | null, houseNumberAddition?: string | null, zipcode?: string | null, place?: string | null, latitude?: number | null, longitude?: number | null, newcomerToken?: string | null, totalCapacity: number, remainingCapacity: number, newcomerAvailableCapacity: number } | null };

export type LocationComponent_NewcomersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  rangeFilter?: InputMaybe<RangeFilter>;
  areaId?: InputMaybe<Scalars['ID']>;
  placementStatus__in?: InputMaybe<Array<PlacementStatus> | PlacementStatus>;
  shouldHaveBeenPlaced?: InputMaybe<Scalars['Boolean']>;
  speaksUkrainian?: InputMaybe<Scalars['Boolean']>;
}>;


export type LocationComponent_NewcomersQuery = { __typename?: 'Query', newcomers: { __typename?: 'QueryNewcomersConnection', edges: Array<{ __typename?: 'QueryNewcomersConnectionEdge', node: { __typename: 'NewComer', id: string, fullName: string, latitude?: number | null, longitude?: number | null } }> } };

export type LocationComponent_SetNewcompoerAvailableCapacityMutationVariables = Exact<{
  locationId: Scalars['ID'];
  newcomerAvailableCapacity: Scalars['Int'];
}>;


export type LocationComponent_SetNewcompoerAvailableCapacityMutation = { __typename?: 'Mutation', setLocationNewcomerAvailableCapacity: { __typename?: 'SetLocationNewcomerAvailableCapacityOutput', locationId: string, newcomerAvailableCapacity?: number | null } };

export type OverviewComponent_ShouldHaveBeenPlacedQueryVariables = Exact<{ [key: string]: never; }>;


export type OverviewComponent_ShouldHaveBeenPlacedQuery = { __typename?: 'Query', newcomers: { __typename?: 'QueryNewcomersConnection', totalCount: number } };

export type OverviewComponent_AreasQueryVariables = Exact<{ [key: string]: never; }>;


export type OverviewComponent_AreasQuery = { __typename?: 'Query', areas: Array<{ __typename?: 'Area', id: string, name: string, category: AreaCategory }> };

export type GeneralNewcomerInformationComponent_RightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralNewcomerInformationComponent_RightsQuery = { __typename?: 'Query', me: { __typename?: 'AuthUserType', id: string, managerHasAccessToSensitiveMessages: boolean } };

export type NewcomerExportComponent_InformationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewcomerExportComponent_InformationQuery = { __typename?: 'Query', newcomer?: { __typename?: 'NewComer', id: string, firstName: string, lastName: string, dateOfBirth?: Date | string | null, age?: number | null, parentFirstName?: string | null, parentLastName?: string | null, parentEmail?: string | null, parentPhone?: string | null, contactFirstName?: string | null, contactLastName?: string | null, contactEmail?: string | null, contactPhone?: string | null, street?: string | null, houseNumber?: string | null, zip?: string | null, city?: string | null, languages: Array<Language>, gender?: Gender | null } | null };

export type NewcomerPlacementInformationComponent_NewcomerFieldsFragment = { __typename?: 'NewComer', id: string, centralSignupRemarks?: string | null, placementStatus?: PlacementStatus | null, poVo: PoVo, placementOffers: Array<{ __typename?: 'PlacementOffer', id: string, date: Date | string, resolution: PlacementOfferResolution, resolutionAt?: Date | string | null, finalized: boolean, location?: { __typename?: 'WegwijzerLocationType', id: string, name: string } | null }>, schoolPlacement?: { __typename: 'WegwijzerLocationType', id: string, name: string } | null };

export type NewcomerPlacementInformationComponent_NewcomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewcomerPlacementInformationComponent_NewcomerQuery = { __typename?: 'Query', newcomer?: { __typename?: 'NewComer', id: string, centralSignupRemarks?: string | null, placementStatus?: PlacementStatus | null, poVo: PoVo, placementOffers: Array<{ __typename?: 'PlacementOffer', id: string, date: Date | string, resolution: PlacementOfferResolution, resolutionAt?: Date | string | null, finalized: boolean, location?: { __typename?: 'WegwijzerLocationType', id: string, name: string } | null }>, schoolPlacement?: { __typename: 'WegwijzerLocationType', id: string, name: string } | null } | null };

export type NewcomerTimelineComponent_TimelineQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewcomerTimelineComponent_TimelineQuery = { __typename?: 'Query', newcomer?: { __typename?: 'NewComer', id: string, timeline: Array<{ __typename?: 'NewComerStatusHistory', id: string, createdAt: Date | string, oldStatus?: PlacementStatus | null, status?: PlacementStatus | null } | { __typename?: 'Note', id: string, createdAt: Date | string, text: string } | { __typename?: 'PlacementOffer', id: string, createdAt: Date | string, location?: { __typename?: 'WegwijzerLocationType', id: string, name: string } | null }> } | null };

type NewcomerTimelineComponent_TimelineFragment_NewComerStatusHistory_Fragment = { __typename?: 'NewComerStatusHistory', id: string, createdAt: Date | string, oldStatus?: PlacementStatus | null, status?: PlacementStatus | null };

type NewcomerTimelineComponent_TimelineFragment_Note_Fragment = { __typename?: 'Note', id: string, createdAt: Date | string, text: string };

type NewcomerTimelineComponent_TimelineFragment_PlacementOffer_Fragment = { __typename?: 'PlacementOffer', id: string, createdAt: Date | string, location?: { __typename?: 'WegwijzerLocationType', id: string, name: string } | null };

export type NewcomerTimelineComponent_TimelineFragmentFragment = NewcomerTimelineComponent_TimelineFragment_NewComerStatusHistory_Fragment | NewcomerTimelineComponent_TimelineFragment_Note_Fragment | NewcomerTimelineComponent_TimelineFragment_PlacementOffer_Fragment;

export type NewcomerTimelineComponent_RightsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewcomerTimelineComponent_RightsQuery = { __typename?: 'Query', me: { __typename?: 'AuthUserType', id: string, managerHasAccessToSensitiveMessages: boolean } };

export type NewcomerComponent_InformationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewcomerComponent_InformationQuery = { __typename?: 'Query', newcomer?: { __typename?: 'NewComer', id: string, firstName: string, lastName: string, placementStatus?: PlacementStatus | null, age?: number | null, poVo: PoVo, poGroup?: number | null, registrationDate: Date | string, longitude?: number | null, latitude?: number | null } | null };

export type PlacementOfferOverviewComponent_PlacementOfferQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacementOfferOverviewComponent_PlacementOfferQuery = { __typename?: 'Query', placementOffers: { __typename?: 'QueryPlacementOffersConnection', edges: Array<{ __typename?: 'QueryPlacementOffersConnectionEdge', node: { __typename?: 'PlacementOffer', id: string, date: Date | string, resolution: PlacementOfferResolution, resolutionAt?: Date | string | null, failureReason?: string | null, finalizedAt?: Date | string | null, finalized: boolean, location?: { __typename?: 'WegwijzerLocationType', id: string, name: string } | null, newcomer: { __typename?: 'NewComer', id: string, firstName: string, lastName: string } } }> } };

export type PlacementOfferComponent_PlacementOfferQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PlacementOfferComponent_PlacementOfferQueryQuery = { __typename?: 'Query', placementOffer?: { __typename?: 'PlacementOffer', id: string, failureReason?: string | null, finalized: boolean, finalizedAt?: Date | string | null, date: Date | string, resolutionAt?: Date | string | null, resolution: PlacementOfferResolution, newcomer: { __typename?: 'NewComer', id: string, firstName: string, lastName: string, placementStatus?: PlacementStatus | null }, location?: { __typename?: 'WegwijzerLocationType', id: string, name: string } | null, capacity?: { __typename?: 'Capacity', id: string, age?: Array<number> | null, description: string } | null, resolutionBy?: { __typename?: 'UserType', id: string, name: string } | null } | null };

export type PlacementOfferComponent_PlacementOfferMutationMutationVariables = Exact<{
  input: CreateOrUpdatePlacementOfferInput;
}>;


export type PlacementOfferComponent_PlacementOfferMutationMutation = { __typename?: 'Mutation', createOrUpdatePlacementOffer: { __typename?: 'UpdatePlacementOfferOutput', errors: Array<{ __typename?: 'ErrorType', field: string }> } };

export type PlacementOfferComponent_RightsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacementOfferComponent_RightsQuery = { __typename?: 'Query', me: { __typename?: 'AuthUserType', id: string, managerHasAccessToSensitiveMessages: boolean } };

export type ReportsComponent__Get_ReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportsComponent__Get_ReportsQuery = { __typename?: 'Query', reports: Array<{ __typename: 'Report', id: string, name: string }> };

export type ReportsComponent__Get_ReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportsComponent__Get_ReportQuery = { __typename?: 'Query', report: { __typename: 'Report', id: string, name: string, downloadAsBase64: string } };

export type UserComponent_Reset_OtpMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserComponent_Reset_OtpMutation = { __typename?: 'Mutation', resetOtp: boolean };

export type UserComponent_SearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type UserComponent_SearchQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserType', id: string, email: string }> };

export type UsersOverviewComponent_UsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type UsersOverviewComponent_UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserType', id: string, name: string, email: string, newcomerLocations: Array<{ __typename?: 'WegwijzerLocationType', id: string, name: string }> }> };

export const NewcomerPlacementInformationComponent_NewcomerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewcomerPlacementInformationComponent_newcomerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewComer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"centralSignupRemarks"}},{"kind":"Field","name":{"kind":"Name","value":"placementStatus"}},{"kind":"Field","name":{"kind":"Name","value":"placementOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"finalized"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WegwijzerLocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schoolPlacement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WegwijzerLocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"poVo"}}]}}]} as unknown as DocumentNode<NewcomerPlacementInformationComponent_NewcomerFieldsFragment, unknown>;
export const NewcomerTimelineComponent_TimelineFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewcomerTimelineComponent_timelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"timelineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewComerStatusHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"oldStatus"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlacementOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WegwijzerLocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewcomerTimelineComponent_TimelineFragmentFragment, unknown>;
export const AppComponent_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppComponent_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AppComponent_UserQuery, AppComponent_UserQueryVariables>;
export const LocationComponent_InformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationComponent_information"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"newcomerToken"}},{"kind":"Field","name":{"kind":"Name","value":"totalCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"newcomerAvailableCapacity"}}]}}]}}]} as unknown as DocumentNode<LocationComponent_InformationQuery, LocationComponent_InformationQueryVariables>;
export const LocationComponent_NewcomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationComponent_newcomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rangeFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RangeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placementStatus__in"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlacementStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldHaveBeenPlaced"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"speaksUkrainian"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newcomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"rangeFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rangeFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"areaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"placementStatus__in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placementStatus__in"}}},{"kind":"Argument","name":{"kind":"Name","value":"shouldHaveBeenPlaced"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldHaveBeenPlaced"}}},{"kind":"Argument","name":{"kind":"Name","value":"speaksUkrainian"},"value":{"kind":"Variable","name":{"kind":"Name","value":"speaksUkrainian"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldFirst"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LocationComponent_NewcomersQuery, LocationComponent_NewcomersQueryVariables>;
export const LocationComponent_SetNewcompoerAvailableCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LocationComponent_setNewcompoerAvailableCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newcomerAvailableCapacity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setLocationNewcomerAvailableCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newcomerAvailableCapacity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newcomerAvailableCapacity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"newcomerAvailableCapacity"}}]}}]}}]} as unknown as DocumentNode<LocationComponent_SetNewcompoerAvailableCapacityMutation, LocationComponent_SetNewcompoerAvailableCapacityMutationVariables>;
export const OverviewComponent_ShouldHaveBeenPlacedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewComponent_shouldHaveBeenPlaced"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newcomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shouldHaveBeenPlaced"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<OverviewComponent_ShouldHaveBeenPlacedQuery, OverviewComponent_ShouldHaveBeenPlacedQueryVariables>;
export const OverviewComponent_AreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewComponent_areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode<OverviewComponent_AreasQuery, OverviewComponent_AreasQueryVariables>;
export const GeneralNewcomerInformationComponent_RightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeneralNewcomerInformationComponent_rights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"managerHasAccessToSensitiveMessages"}}]}}]}}]} as unknown as DocumentNode<GeneralNewcomerInformationComponent_RightsQuery, GeneralNewcomerInformationComponent_RightsQueryVariables>;
export const NewcomerExportComponent_InformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewcomerExportComponent_information"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newcomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"parentFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"parentLastName"}},{"kind":"Field","name":{"kind":"Name","value":"parentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"parentPhone"}},{"kind":"Field","name":{"kind":"Name","value":"contactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}}]}}]} as unknown as DocumentNode<NewcomerExportComponent_InformationQuery, NewcomerExportComponent_InformationQueryVariables>;
export const NewcomerPlacementInformationComponent_NewcomerDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewcomerPlacementInformationComponent_newcomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newcomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NewcomerPlacementInformationComponent_newcomerFields"}}]}}]}},...NewcomerPlacementInformationComponent_NewcomerFieldsFragmentDoc.definitions]} as unknown as DocumentNode<NewcomerPlacementInformationComponent_NewcomerQuery, NewcomerPlacementInformationComponent_NewcomerQueryVariables>;
export const NewcomerTimelineComponent_TimelineDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewcomerTimelineComponent_timeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newcomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NewcomerTimelineComponent_timelineFragment"}}]}}]}}]}},...NewcomerTimelineComponent_TimelineFragmentFragmentDoc.definitions]} as unknown as DocumentNode<NewcomerTimelineComponent_TimelineQuery, NewcomerTimelineComponent_TimelineQueryVariables>;
export const NewcomerTimelineComponent_RightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewcomerTimelineComponent_rights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"managerHasAccessToSensitiveMessages"}}]}}]}}]} as unknown as DocumentNode<NewcomerTimelineComponent_RightsQuery, NewcomerTimelineComponent_RightsQueryVariables>;
export const NewcomerComponent_InformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewcomerComponent_information"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newcomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"placementStatus"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"poVo"}},{"kind":"Field","name":{"kind":"Name","value":"poGroup"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]} as unknown as DocumentNode<NewcomerComponent_InformationQuery, NewcomerComponent_InformationQueryVariables>;
export const PlacementOfferOverviewComponent_PlacementOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlacementOfferOverviewComponent_placementOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placementOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"failureReason"}},{"kind":"Field","name":{"kind":"Name","value":"finalizedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finalized"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WegwijzerLocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newcomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PlacementOfferOverviewComponent_PlacementOfferQuery, PlacementOfferOverviewComponent_PlacementOfferQueryVariables>;
export const PlacementOfferComponent_PlacementOfferQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlacementOfferComponent_placementOfferQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placementOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"failureReason"}},{"kind":"Field","name":{"kind":"Name","value":"finalized"}},{"kind":"Field","name":{"kind":"Name","value":"finalizedAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"newcomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"placementStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WegwijzerLocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"capacity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolutionBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PlacementOfferComponent_PlacementOfferQueryQuery, PlacementOfferComponent_PlacementOfferQueryQueryVariables>;
export const PlacementOfferComponent_PlacementOfferMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlacementOfferComponent_placementOfferMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"createOrUpdatePlacementOfferInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrUpdatePlacementOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]} as unknown as DocumentNode<PlacementOfferComponent_PlacementOfferMutationMutation, PlacementOfferComponent_PlacementOfferMutationMutationVariables>;
export const PlacementOfferComponent_RightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlacementOfferComponent_rights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"managerHasAccessToSensitiveMessages"}}]}}]}}]} as unknown as DocumentNode<PlacementOfferComponent_RightsQuery, PlacementOfferComponent_RightsQueryVariables>;
export const ReportsComponent__Get_ReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportsComponent__get_reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ReportsComponent__Get_ReportsQuery, ReportsComponent__Get_ReportsQueryVariables>;
export const ReportsComponent__Get_ReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportsComponent__get_report"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"downloadAsBase64"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ReportsComponent__Get_ReportQuery, ReportsComponent__Get_ReportQueryVariables>;
export const UserComponent_Reset_OtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserComponent_reset_otp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<UserComponent_Reset_OtpMutation, UserComponent_Reset_OtpMutationVariables>;
export const UserComponent_SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserComponent_search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"newcomerUser"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UserComponent_SearchQuery, UserComponent_SearchQueryVariables>;
export const UsersOverviewComponent_UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersOverviewComponent_users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"newcomerLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UsersOverviewComponent_UsersQuery, UsersOverviewComponent_UsersQueryVariables>;